import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'
import store from './store'
import env from './config/env.example.js';
import {getIdentity} from './helpers/initVue.js'
import Push from 'push.js'
import Croppa from 'vue-croppa';

delete Icon.Default.prototype._getIconUrl
//import socketio  from 'socket.io'
//import VueSocketIO from 'vue-socket.io'

import * as io from 'socket.io-client'
import VueSocketIO from 'vue-socket.io-extended'
delete Icon.Default.prototype._getIconUrl

function loader(type){
  var loader=document.getElementById('loader-initial');
  if(type=='play'){
    loader.style.display='flex'    
  } 
  else{
    loader.style.display='none'    
  } 
}
activeSocket()
function activeSocket(){
  var {token}=getIdentity();
  var SocketInstance;
  if(token){
    SocketInstance = io(env.serverweb,{query: 'token='+token});
  }
  else{
    SocketInstance = io(env.serverweb);
  }
  Vue.use(VueSocketIO,SocketInstance)
}
axios.interceptors.request.use(config=>{  
    if(!config.url.includes('quien ayudar')){
      loader('play');      
    }
    var token=localStorage.getItem('tok')||null;
    var user=JSON.parse(localStorage.getItem('iden'))||null;
    config.headers["X-Access-Token"]=token;
    config.headers["X-Access-Id"]=user!=null?user._id:null;
    
    return config; 
  },
  error=>{
    loader('stop');    
    return Promise.reject(error);
  }
  );
  axios.interceptors.response.use(response=>{   
    loader('stop');    
    return response; 
  },
  error=>{
    loader('stop');    
    const {config}=error;
    return Promise.reject(error);
  }
);
//Vue.use(VueHead)
Vue.mixin({ 
 
  data:()=>({
    Push: Push,
  }),
  methods: {
    tabActive:function(array=[],index){
      for (let i = 0; i < array.length; i++) {
        array[i].active=false;                
      }
      array[index].active=true;  
      return array;   
    },
      notificacionBasica(data,mesg='',url='') {
        // var message=data==null?mesg:data.user?data.user.message:data.message;
        // var name=data==null?"Gootwork":data.message?data.name:"Gootwork";
        // try{
        //     var me=this;
        //     this.Push.config({})
        //     this.Push.create(name, {
        //         body: message,
        //         icon: '/favicon.ico',
        //         requireInteraction: true,
        //         timeout: 10000,
        //         link:`/${url}`,
        //         onClick: function () {
        //             window.focus();
        //             if(url!='')  {
        //               if(url=='helping-user'){
        //                 var user=JSON.parse(localStorage.getItem('user'))||localStorage.getItem('user');
        //                 var iden=JSON.parse(localStorage.getItem('iden'))||localStorage.getItem('iden');
                        
        //                 if(user!=null){
        //                   var user_send={
        //                     id_conversation:data.user._id_user,
        //                     location:data.location_user,
        //                     user:{
        //                         _id:iden?iden._id:null,
        //                         name:user.fullname,
        //                         avatar:user.photo,
        //                         phone:user.phone
        //                     }
        //                 }
        //                 me.$socket.emit('helping:user',user_send)
        //                 me.$router.push(`/conversation-user?type=user-help&datauser=${data.user._id_user}&color=${data.color}`)  
        //                }
        //               }
        //               else if(url=='message'){
        //                 me.$router.push(`/conversation-user?type=user&datauser=${data.id_user}&color=#000`)  
        //               }
        //               else{
        //                 window.location.href=`${env.host}${url}`
        //               }
        //             } 
        //             this.close();
        //         }
        //     });
        // }
        // catch($e){
        //     console.log($e)
        // }
      },
      activeSocket:()=>{
        activeSocket()
      },
      meta:(property,description,content)=>{
        var meta=document.querySelector(`meta[${property?'property':'name'}="${description}"]`)
        if(meta){
          meta.setAttribute("content", content);
        }
        else{
          var meta = document.createElement('meta');
          meta.setAttribute(property?'property':'name', description);//'og:url'
          meta.content = content
          document.getElementsByTagName('head')[0].appendChild(meta);
        }
        
      },
      capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
      getCleanedString:function(cadena){
          // Definimos los caracteres que queremos eliminar
          var specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";
          // Los eliminamos todos
          for (var i = 0; i < specialChars.length; i++) {
              cadena= cadena.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
          }   
          // Lo queremos devolver limpio en minusculas
          cadena = cadena.toLowerCase();

          // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
          cadena = cadena.replace(/ /g,"");

          // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
          cadena = cadena.replace(/á/gi,"a");
          cadena = cadena.replace(/é/gi,"e");
          cadena = cadena.replace(/í/gi,"i");
          cadena = cadena.replace(/ó/gi,"o");
          cadena = cadena.replace(/ú/gi,"u");
          cadena = cadena.replace(/ñ/gi,"n");
          return cadena;
      },
      hiddenDropdown:function(){
        var clas=document.getElementsByClassName('JDropdown');
        for (let index = 0; index < clas.length; index++) {
            const element = clas[index];
            element.classList.remove('show')
        }
      },
      listarTipoCategoria:async(categoria)=>{
          return await axios.get("tipo?categoria="+categoria)
          .then(response =>{
              var {data,status}=response;
              return data;
          })
          .catch(error=>{
              console.log(error);
          })
      },
      ubigeoDirection:async (data)=>{
          var url=`https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1&accept-language=es&zoom=18&lat=${data.lat}&lon=${data.lng}`
          return await axios.get(url,{ 'headers': { 'Access-Control-Allow-Origin': '*' } })
          .then(response=>{
              var {data}=response;
              return data;
          })
          .catch(error=>{
          });
      }
  } 
}) 

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})
//Vue.loadScript("@/utils/count.js")

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  window.scroll(0,0)
  next()
})


/*******************************************************
 * * Configuración de los títulos de cada ruta
 *******************************************************/
router.beforeEach((to, from, next) => {

  var element = document.getElementById("body");
  var user=JSON.parse(localStorage.getItem('iden'))||null;
  if((to.fullPath=='/'||to.fullPath=='/home')&user!=null){
    element.classList.remove("active-home");
    console.log('remove')

    element.classList.add("active-home");

  }
  else{
    element.classList.remove("active-home");
  }

  
  document.title = to.meta.title
  window.scroll(0,0)
  next()
})
Vue.use(Croppa);


//

window.onclick=(e)=>{
  var jdropdowns=document.getElementsByClassName('JDropdown');
   for (let index = 0; index < jdropdowns.length; index++) {
     const jdropdown = jdropdowns[index];
     if(jdropdown==undefined){
          //auto=false;
          return;
      }
      
      var btn=e.toElement.parentElement.classList;
      for (let i = 0; i < btn.length; i++) {
          const element = btn[i];
          if(element=='JBtn-dropdown-items'){
              return;
          }
      }
      if(!e.target.matches('.JBtn-dropdown')&&!e.target.matches('.JBtn-dropdown-items')){
              var openDropdown = jdropdown;
              if(openDropdown.classList.contains('show')){
                  openDropdown.classList.remove('show')
              }
          
              
      }
      if(!jdropdown.classList.contains('show')){
          //auto=false;
          var openDropdown = jdropdown;
          openDropdown.classList.remove('show')
        
      }
      
   }
   
}
new Vue({
  router,
  store,
  render: h => h(App),
  sockets:{
    connect () {
        console.log('connected to chat server')
    },
  }
}).$mount('#app')

